import "normalize.css"; //样式初始化
import "@/styles/reset";
import "@/styles/ElementPlus";
import "element-plus/dist/index.css";
import { createApp, defineAsyncComponent } from "vue";
import App from "./App.vue";
import router from "./router"; //路由
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import directives from "@/directives/index.js";
import { createPinia } from "pinia";
import "virtual:svg-icons-register";
import routerAuth from "@/utils/routerAuth.js";
import Print from 'vue3-print-nb';
const app = createApp(App);

(async function () {
  // 添加动态路由
  await routerAuth(router);
  // pinia
  app.use(createPinia());
  // router
  app.use(router);
  // 注册饿了么icon
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
  // 注册全局组件
  const components = import.meta.glob("@/components/Global/**/*.vue");
  Object.entries(components).forEach(([path, component]) => {
    const name = path.split("/").pop()?.split(".")[0] || "";
    app.component(name, defineAsyncComponent(component));
  });
  // 注册全局指令
  app.use(directives);
  app.use(Print);
  // 打印
  app.mount("#app");
})();